"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../../styles");

var styles = {
  root: {
    cursor: 'pointer',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '45px',
    fontSize: '18px',
    outline: 'none',
    border: 'none',
    borderBottom: "1px solid ".concat(_styles.colors.ash),
    transition: 'all 0.3s',
    fontWeight: function fontWeight(_ref) {
      var isActiveYear = _ref.isActiveYear;
      return isActiveYear ? 'bold' : 'normal';
    },
    background: function background(_ref2) {
      var isActiveYear = _ref2.isActiveYear;
      return isActiveYear ? _styles.colors.charcoal : 'transparent';
    },
    color: function color(_ref3) {
      var year = _ref3.year,
          currentYear = _ref3.currentYear,
          isActiveYear = _ref3.isActiveYear;
      if (year >= currentYear || isActiveYear) return _styles.colors.white;
      return _styles.colors.ash;
    },
    '&:hover': {
      background: _styles.colors.raven
    }
  },
  checkmark: {
    fill: _styles.colors.white,
    position: 'absolute',
    left: '90px',
    height: '15px',
    width: '15px'
  }
};
var _default = styles;
exports["default"] = _default;